import {
  BOOKS_PENDING,
  BOOKS_DOWNLOADED,
  BOOKS_FAILED,
  BOOK_DOWNLOADED, BOOK_REMOVED, BOOK_SENDING,
} from './types';

export const INITIAL_STATE = {
  error: null,
  content: null,
  pending: false,
  sending: false,
};

export default function (state = INITIAL_STATE, action) {
  let books = [];
  let bookIndex = -1;
  switch (action.type) {
    case BOOKS_PENDING:
      return {
        ...state,
        error: null,
        pending: true,
      };
    case BOOKS_DOWNLOADED:
      return {
        error: null,
        pending: false,
        sending: false,
        content: action.payload,
      };
    case BOOK_DOWNLOADED:
      if (state.content) {
        books = state.content.slice();
        bookIndex = books.findIndex((book) => book.id === action.payload.id);
      }
      if (bookIndex === -1) {
        books.push(action.payload);
      } else {
        books[bookIndex] = action.payload;
      }
      return {
        error: null,
        pending: false,
        sending: false,
        content: books,
      };
    case BOOK_SENDING:
      return {
        ...state,
        sending: true,
      };
    case BOOK_REMOVED: {
      if (state.content) {
        books = state.content.slice();
        bookIndex = books.findIndex((book) => book.id === action.payload);
        if (bookIndex !== -1) {
          books.splice(bookIndex, 1);
        }
      }
      return {
        ...state,
        error: null,
        pending: false,
        sending: false,
        content: books,
      };
    }
    case BOOKS_FAILED:
      return {
        ...state,
        error: action.payload,
        pending: false,
        sending: false,
      };
    default:
      break;
  }
  return state;
}



// WEBPACK FOOTER //
// ./src/store/books/reducers.js